export default __webpack_public_path__ + "static/media/file_upload.efa74fb3.svg";